<template>
  <div
    :class="[
      'loading-wrapper',
      fullscreen ? 'position-fixed top-0 start-0 w-100 h-100' : '',
      blur ? 'backdrop-blur' : '',
    ]"
  >
    <div class="spinner-container">
      <b-spinner :variant="variant" :type="spinnerType"></b-spinner>
      <div v-if="showLabel" class="mt-2 loading-label">
        {{ label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    label: {
      type: String,
      default: "",
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    spinnerType: {
      type: String,
      default: "border", // or 'grow'
    },
    small: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    blur: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>

<style scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 9999;
}

.backdrop-blur {
  backdrop-filter: blur(8px);
}

.spinner-container {
  text-align: center;
  padding: 1rem;
  border-radius: 0.75rem;
}

.loading-label {
  font-size: 0.9rem;
  color: #555;
}
</style>
